import styled from 'styled-components';
import { Link } from 'gatsby';

export const Logo = styled(Link)`
  &.logo {
    position: relative;
    display: flex;
    flex-flow: column;
    justify-content: start;

    @media (max-width: 1099px) {
      justify-content: center;
    }
    &[dir='rtl'] {
      padding: 0 15px 0 0;
    }

    &[dir='ltr'] {
      padding: 10px 15px 0px 0px;
    }

    @media (max-width: 1199px) {
      &[dir='ltr'] {
        padding: 10px 0 0 15px;
      }
    }

    @media (max-width: 1099px) {
      position: relative;
      height: 115px;
    }

    @media (max-width: 767px) {
        &.free-zone {
          height: 92px;
        }
      }

    .dwtclogo {
      width: 130px;
      height: 90px;
      background-image: url(/svg/dwtc-logo-white-v2.svg);
      background-repeat: no-repeat;

      @media (max-width: 1099px) {
        background-size: 145px;
        width: 112px;
        height: 78px;
        background-image: url(/svg/dwtc-logo-dark.svg);

        &.free-zone {
          background-image: url(/svg/dwtc-logo-white-v2.svg) !important;
        }
      }

      @media (max-width: 767px) {
        &.free-zone {
          background-size: 104px;
          width: 78px;
          height: 55px;
        }

    }
  }
`;
